<script>
  import { style, blocklist, pop, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
  export let pictures = blocklist(block, 'pictures').reverse();
</script>

<!-- -------   START CONTENT 1 - title & description and 6 IMAGES   -------- -->
<section style="{style(block)}">
  <div class="container">
    <div class="row min-vh-25">
      <div class="col-sm-4 col-5 mb-sm-0 mb-3">
        <div style="background-image: url({pop(pictures, (pic) => image(pic, 'image', [600, null]))})" class="w-100 h-100 border-radius-lg bg-cover"></div>
      </div>
      <div class="col-sm-3 col-7 mb-sm-0 mb-3">
        <div style="background-image: url({pop(pictures, (pic) => image(pic, 'image', [600, null]))})" class="w-100 h-100 border-radius-lg bg-cover"></div>
      </div>
      <div class="col-sm-5 mb-sm-0 mb-3">
        <div style="background-image: url({pop(pictures, (pic) => image(pic, 'image', [600, null]))})" class="w-100 h-100 border-radius-lg bg-cover"></div>
      </div>
    </div>
    <div class="row min-vh-25 mt-4">
      <div class="col-sm-3 col-7 mb-sm-0 mb-3">
        <div style="background-image: url({pop(pictures, (pic) => image(pic, 'image', [600, null]))})" class="w-100 h-100 border-radius-lg bg-cover"></div>
      </div>
      <div class="col-sm-5 col-5 mb-sm-0 mb-3">
        <div style="background-image: url({pop(pictures, (pic) => image(pic, 'image', [600, null]))})" class="w-100 h-100 border-radius-lg bg-cover"></div>
      </div>
      <div class="col-sm-4 mb-sm-0 mb-3">
        <div style="background-image: url({pop(pictures, (pic) => image(pic, 'image', [600, null]))})" class="w-100 h-100 border-radius-lg bg-cover"></div>
      </div>
    </div>
  </div>
</section>
<!-- -------   END CONTENT 1 - title & description and 6 IMAGES   -------- -->
